import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const RulesPreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${Tokens.ColorTextPrimary};
  }

  h4 {
    margin: 0 0 12px 0;
    font-size: 16px;
    font-weight: 600;
    color: ${Tokens.ColorTextPrimary};
  }

  p {
    margin: 0;
    font-size: 14px;
    color: ${Tokens.ColorTextSecondary};
    font-style: italic;
  }

  > div {
    border: 1px solid ${Tokens.ColorBorder};
    border-radius: 8px;
    padding: 16px;
    background-color: ${Tokens.ColorWhite};
    min-height: 120px;
  }
`

export const TermsPreviewSection = styled.div`
  margin-bottom: 24px;

  h5 {
    margin: 0 0 12px 0;
    font-size: 14px;
    font-weight: 600;
    color: ${Tokens.ColorTextPrimary};
  }
`

export const TermsPreviewGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
`

export const TermsPreviewItem = styled.div`
  h6 {
    margin: 0 0 8px 0;
    font-size: 14px;
    font-weight: 600;
    color: ${Tokens.ColorTextPrimary};
  }
`

export const NoTermsText = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${Tokens.ColorTextSecondary};
  font-style: italic;
`

export const PreviewContainer = styled.div`
  > div:first-child {
    margin-bottom: 24px;
  }
`

export const GeneralRulesTitle = styled.h4`
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const SpecificRulesTitle = styled.h4`
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const NoRulesText = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${Tokens.ColorTextSecondary};
  font-style: italic;
`

export const RuleNumberSpan = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #9ca3af;
  flex-shrink: 0;
  min-width: 24px;
  margin-top: 1px;
`

export const RuleItem = styled.div<{ $isBullet?: boolean }>`
  font-size: 14px;
  color: ${Tokens.ColorTextPrimary};
  line-height: 1.6;
  padding: 6px 0;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  position: relative;

  ${({ $isBullet }) =>
    $isBullet &&
    `
    padding-left: 20px;
    
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 12px;
      width: 6px;
      height: 6px;
      background-color: #9CA3AF;
      border-radius: 50%;
      flex-shrink: 0;
    }
  `}

  &:last-child {
    margin-bottom: 0;
  }
`
